var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlertIcons(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2898 4.61002L1.81978 18.75C1.64514 19.0524 1.55274 19.3953 1.55177 19.7445C1.55079 20.0938 1.64127 20.4372 1.8142 20.7405C1.98714 21.0439 2.2365 21.2968 2.53748 21.4739C2.83847 21.651 3.18058 21.7462 3.52978 21.75H20.4698C20.819 21.7462 21.1611 21.651 21.4621 21.4739C21.7631 21.2968 22.0124 21.0439 22.1854 20.7405C22.3583 20.4372 22.4488 20.0938 22.4478 19.7445C22.4468 19.3953 22.3544 19.0524 22.1798 18.75L13.7098 4.61002C13.5315 4.31613 13.2805 4.07314 12.981 3.90451C12.6814 3.73587 12.3435 3.64728 11.9998 3.64728C11.656 3.64728 11.3181 3.73587 11.0186 3.90451C10.7191 4.07314 10.468 4.31613 10.2898 4.61002V4.61002Z",
    stroke: "#BF2600",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 9.75V13.75",
    stroke: "#BF2600",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 17.75H12.01",
    stroke: "#BF2600",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertIcons);
export default __webpack_public_path__ + "static/media/alert-icons.b23f418f276c11fa2b400d7ce7c11738.svg";
export { ForwardRef as ReactComponent };